import { IdIndexedUserGroups } from 'data/userGroups/types'
import { PairingStageFilter } from 'scenes/Dashboard/components/PairingStageFilter'
import { Deal } from 'scenes/Dashboard/data/deals/types'

import { IdIndexedCorporate } from '../../../../../entities-next/corporate'

export type DealManagerState = {
  readonly isLoading: boolean
  readonly filters: PairingManagerFilters
  readonly dealsOrder: Deal[]
  readonly users: IdIndexedCorporate
  readonly userGroups: IdIndexedUserGroups
}

export enum CorporateStatusFilter {
  all = 'all',
  active = 'active',
  inactive = 'inactive',
}

export enum IsValidFilter {
  all = 'all',
  isValid = 'isValid',
  isNotValid = 'isNotValid',
  unknown = 'unknown',
}

export enum ProcessedByOpsFilter {
  both = 'both',
  isProcessedByOps = 'isProcessedByOps',
  isNonProcessedByOps = 'isNonProcessedByOps',
}

export enum DealSourceFilter {
  all = 'all',
  outbound = 'Outbound',
  inbound = 'Inbound',
}

export type PairingManagerFilters = {
  readonly organizationSearch: string | null
  readonly corporateSearch: string | null
  readonly scoutingCampaignId: string | null
  readonly corporateStatusFilter: CorporateStatusFilter
  readonly currentPage: number
  readonly limit: number
  readonly isValidFilter: IsValidFilter
  readonly finderStagesFilter: PairingStageFilter[]
}

export const DEAL_MANAGER_STATE_ID = 'DealManager'
